import React, { useState } from 'react';
import { PlayCircle, X } from 'lucide-react';
import HeadersNonAuth from '../../../components/base/HeadersNonAuth';
import { INTRO_VIDEO_URL } from '../../../config/videos';
// import WhyQuantumFlo from './components/WhyQuantumFlo';
// import Solutions from './components/Solutions';
// import HowItWorks from './components/HowItWorks';
// import Pricing from './components/Pricing';
// import Company from './components/Company';

//import Slider from "react-slick";
//import "slick-carousel/slick/slick.css"; 
//import "slick-carousel/slick/slick-theme.css";
import { Link } from 'react-router-dom';
import './components/index.css';

import SlideOne from './components/SlideOne';
import SlideTwo from './components/SlideTwo';
//import SlideThree from './components/SlideThree';
//import SlideFour from './components/SlideFour';
import Section_1 from './components/section-1';
import Section_2 from './components/section-2';
import AutoAlgoTrial from './components/AutoAlgoTrial';

import HomeSection1 from './components/Section1';
import KajabiFormEmbed from './components/KajabiFormEmbed';

import { DiVim } from 'react-icons/di';

const HomePage = () => {
  const [showVideo, setShowVideo] = useState(false);

  // When video modal is shown, prevent body scrolling
  React.useEffect(() => {
    if (showVideo) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
    
    return () => {
      document.body.style.overflow = '';
    };
  }, [showVideo]);
   
  // slick slider
  const sliderSettings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 5000,
    adaptiveHeight: true
  };

  return (
    <div className="bg-[#0b0d2a] text-white font-sans">
      <HeadersNonAuth />
      <br />
      <br />
      
      {/* slider */}
     
      <div style={{ width: '90%', margin: '0 auto', paddingTop: '50px' }}>
       
         {/*<Slider {...sliderSettings}>
          
                
                  <SlideOne setShowVideo={setShowVideo} />
                   <SlideTwo setShowVideo={setShowVideo} />
                  
         
         </Slider> */}
       
      </div>
      
      <div style={{clear: 'both'}}></div>
      {/* Section 1 */}
      {/* <HomeSection1 /> */}
      { <Section_1 setShowVideo={setShowVideo} /> }
      <AutoAlgoTrial />
      { <Section_2 /> }


      {/* Video Modal */}
      {showVideo && (
        <div className="fixed inset-0 bg-black bg-opacity-80 z-50 flex items-center justify-center">
          <div className="relative w-full max-w-3xl px-4">
            <button
              onClick={() => setShowVideo(false)}
              className="absolute top-2 right-2 text-white bg-black/60 p-2 rounded-full z-50"
            >
              <X />
            </button>
            
            <video controls autoPlay className="w-full max-h-[80vh] rounded-lg shadow-lg" controlsList="nodownload">
              <source src={INTRO_VIDEO_URL} type="video/mp4" />
              Your browser does not support the video tag.
            </video>
          </div>
        </div>
      )}
      {/* <WhyQuantumFlo />
      <Solutions/>
      <HowItWorks/>
      <Pricing/>
      <Company/> */}
    </div>
  );
};

export default HomePage;
